export const limitsDefaultValues = {
  isTotalLimited: true,
  isBookingContactLimited: true,
  totalLimit: 500,
  bookingContactLimit: 1,
};
